import { Activity, CurdDataSetConfig, FormFieldType } from '../types';
import { durationToString, toDateFormat, toTimeFormat } from '@mri/functions';

export const activityDataSetConfig: CurdDataSetConfig<Activity> = {
  entityName: 'Actividad',
  collectionName: 'Actividades',
  gatewayUrl: 'activities',
  baseBreadcrumb: 'activities',
  list: {
    pageConfig: {
      title: 'Reporte de actividades',
      breadcrumb: [
        {
          title: 'Reportes',
          type: 'item',
        },
        {
          title: 'Actividades',
          type: 'item',
          link: '/reports/activities/list',
          pageName: 'Reporte de actividades'
        }
      ]
    },
    table: {
      columns: [
        {
          key: 'mobileName', label: 'Placa',
          getValue: ({ element }) => element.mobile?.name || 'No definido'
        },
        { key: 'day', label: 'Dia' },

        { key: 'odometer', label: 'Odometro' },
        {
          key: 'powerOnTime', label: 'Tiempo encendido',
          getValue: ({ element }) => {
            const startTime = new Date(element.firstNode.deviceTime);
            const endTime = new Date(element.lastNode?.deviceTime || new Date());
            return durationToString(endTime.getTime() - startTime.getTime());
          }
        },
        {
          key: 'powerOnDeviceTime', label: 'Hora de encendido',
          getValue: ({ element }) => toTimeFormat(element.firstNode.deviceTime)
        },
        {
          key: 'powerOffDeviceTime', label: 'Hora de apagado',
          getValue: ({ element }) => element.lastNode?.deviceTime ? toTimeFormat(element.lastNode?.deviceTime): ''
        },
        {
          key: 'powerOnAddress', label: 'Direccion de Encendido',
          getValue: ({ element }) => {
            const address = element.firstNode.address || 'No definido';

            return `<span class="text-expansible">${address}</span>`;
          }
        },
        {
          key: 'powerOffAddress', label: 'Direccion de Apagado',
          getValue: ({ element }) => {
            const address = element.lastNode?.address || 'No definido';

            return `<span class="text-expansible">${address}</span>`;
          }
        }
      ],
      noInitLoad: true,
      modeFilter: 'top'
    },
    actionsKeys: [],
    filter: [
      {
        key: 'mobileId',
        label: 'Vehiculo',
        type: FormFieldType.OPTIONS_MULTIPLE,
        optionsGateway: 'mobiles',
        containerClass: 'col-12 col-md-6'
      },
      {
        key: 'day',
        label: 'Dia',
        type: FormFieldType.DATE,
        containerClass: 'col-12 col-md-6',
        fillDefaultValue: () => toDateFormat(new Date())
      },
    ],
  },
  pages: ['list']
};
